import { MobileMPU } from '@public/components/Ads/MobileMPU';
import { MPU } from '@public/components/Ads/MPU';
import clsx from 'clsx';

import styles from './StandardSidebar.module.scss';

interface StandardSidebarProps {
  children?: React.ReactNode;
  className?: string;
}

export const StandardSidebar = ({
  children,
  className,
}: StandardSidebarProps) => {
  return (
    <aside className={clsx(styles.sidebar, className)}>
      <MPU id="mpu_top" />
      {children}
      <MobileMPU id="mobile_mpu_middle" incontent />
      <MPU id="mpu_middle" />
    </aside>
  );
};
